import angular from 'angular'
import PlaylistComposeComponent from './playlist-compose.component'
import composeStepper from './compose-stepper'
import takeoverPanel from './takeover-panel'

import filters from 'components/filters/filters.js'
import dragDropRow from 'common/drag-drop-row.directive'
import jumbotronDialog from 'common/jumbotron-dialog.directive'

import SceneService from 'common/scene.service'
import SceneCollectionService from 'common/scenecollection.service'
import SceneCollectionItemService from 'common/scenecollectionitem.service'
import FileMediaService from 'common/file-media.service'
import SocialMediaService from 'common/social-media.service'
import ServiceAnnouncementsService from 'common/service-announcements.service'
import MediaLabelService from 'common/medialabel.service'

export default angular
  .module('playlistCompose', [
    filters,
    dragDropRow,
    jumbotronDialog,
    composeStepper,
    takeoverPanel,
    SceneService,
    SceneCollectionService,
    SceneCollectionItemService,
    FileMediaService,
    SocialMediaService,
    ServiceAnnouncementsService,
    MediaLabelService
  ])
  .component('playlistCompose', PlaylistComposeComponent)
  .name
